
import { makeStyles } from '@fluentui/react-components';
import React from 'react'
import { TabButton } from '../../components/TabButton';
import { rootUseStyles } from '../../taskpane/fluent-style';
import { useResultStore } from '../../providers/ResultProvider';
import { parseAIResult } from '../../utils/parseAIResult';
import InsightResultsContent from './components/InsightResultsContent';
import { useQuery } from '@tanstack/react-query';
import { getScanResultByGroupId } from '../../api';
import { useTabStore } from '../../providers/TabProvider';

const useStyles = makeStyles({
  main: {
    flex: 1,
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    overflow: "hidden",
  },
  section1: {
    flex: 1,
    overflowY: "scroll",
    overflowX: "hidden",
    paddingLeft: "15px",
    paddingRight: "5px",
  },
  section2: {
    padding: "0px 15px",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },


});

export default function InsightResults() {
  const insightData = useResultStore((s) => s.insightData);
  const parsedAIResult = parseAIResult(insightData?.ai_email_analysis_result);
  const setDeepScanData = useResultStore((s) => s.setDeepScanData);
  const emailData = useTabStore((s) => s.emailData);

  // Pre-check: when AI Insight tab loads, check if a deep scan result already
  // exists for this email (by fingerprint). If it does, populate the store so
  // RunningDeepScanButton shows "View Scan Results" and the tab becomes enabled.
  const { data: existingDeepScan, isFetching: isCheckingDeepScan } = useQuery({
    queryKey: ['deep-scan-precheck', emailData?.emailFingerprint],
    enabled: !!emailData?.emailFingerprint,
    retry: false,
    queryFn: async () => {
      return await getScanResultByGroupId({ emailData });
    },
  });

  React.useEffect(() => {
    // Only write to store if response looks like a valid deep scan result,
    // not an error object or empty response.
    const isValidResult = existingDeepScan
      && typeof existingDeepScan === 'object'
      && !('detail' in existingDeepScan) // 404 responses have a "detail" key
      && ('result' in existingDeepScan || 'overall_status' in existingDeepScan);

    if (isValidResult) {
      // existingDeepScan is ScanGroupResponseType (result of getScanResultByGroupId).
      // We store it as DeepScanResultType so that RunningDeepScanButton and TabButton
      // know a prior scan exists. The full typed data is used in ThreatList/HistoryView.
      setDeepScanData(existingDeepScan as unknown as any);
    }
  }, [existingDeepScan, setDeepScanData]);

  return (
    <main className={`${rootUseStyles().root} ${useStyles().main}`}>
      <TabButton />
      <InsightResultsContent parsedAIResult={parsedAIResult} insightData={insightData} isCheckingDeepScan={isCheckingDeepScan} />
    </main>
  )
}
